// extracted by mini-css-extract-plugin
module.exports = {"modeSelector":"LastDetectedFullReport_modeSelector__TZRkm"};